import { NgModule } from '@angular/core';

// services
import { FiltrationService } from './services/filtration.service';

// components
import { FiltrationComponent } from './filtration.component';

// Modules
import { SharedModule } from 'src/app/shared.modules/shared.module';


@NgModule({
  declarations: [ FiltrationComponent ],
  imports: [ 
    // Modules
    SharedModule
  ],
  exports: [ FiltrationComponent ],
  providers: [ FiltrationService ]
})
export class FiltrationModule { }
